export default "__VITE_ASSET__DDomXhAD__"